import { NAME } from './constants';

export const ADD_SEGMENT_MODAL_OPEN_STATUS = `${NAME}/ADD_SEGMENT_MODAL_OPEN_STATUS`;

export const DELETE_SEGMENT = `${NAME}/DELETE_SEGMENT`;
export const DELETE_SEGMENT_FAILURE = `${NAME}/DELETE_SEGMENT_FAILURE`;
export const DELETE_SEGMENT_SUCCESS = `${NAME}/DELETE_SEGMENT_SUCCESS`;

export const EDIT_SEGMENT = `${NAME}/EDIT_SEGMENT`;
export const EDIT_SEGMENT_FAILURE = `${NAME}/EDIT_SEGMENT_FAILURE`;
export const EDIT_SEGMENT_SUCCESS = `${NAME}/EDIT_SEGMENT_SUCCESS`;

export const ENABLED_EDITION = `${NAME}/ENABLED_EDITION`;
export const ENABLED_EDITION_FAILURE = `${NAME}/ENABLED_EDITION_FAILURE`;
export const ENABLED_EDITION_SUCCESS = `${NAME}/ENABLED_EDITION_SUCCESS`;

export const FETCH_OFFER_INFO_PATERN = `${NAME}/FETCH_OFFER_INFO_PATERN`;
export const FETCH_OFFER_INFO_PATERN_FAILURE = `${NAME}/FETCH_OFFER_INFO_PATERN_FAILURE`;
export const FETCH_OFFER_INFO_PATERN_SUCCESS = `${NAME}/FETCH_OFFER_INFO_PATERN_SUCCESS`;

export const FETCH_OFFER_PANELS = `${NAME}/FETCH_OFFER_PANELS`;
export const FETCH_OFFER_PANELS_FAILURE = `${NAME}/FETCH_OFFER_PANELS_FAILURE`;
export const FETCH_OFFER_PANELS_SUCCESS = `${NAME}/FETCH_OFFER_PANELS_SUCCESS`;

export const FETCH_PARENT_FIELD_SEGMENT = `${NAME}/FETCH_SEGMENTS`;
export const FETCH_PARENT_FIELD_SEGMENT_FAILURE = `${NAME}/FETCH_PARENT_FIELD_SEGMENT_FAILURE`;
export const FETCH_PARENT_FIELD_SEGMENT_SUCCESS = `${NAME}/FETCH_PARENT_FIELD_SEGMENT_SUCCESS`;

export const GENERATE_PROPOSAL = `${NAME}/GENERATE_PROPOSAL`;
export const GENERATE_PROPOSAL_FAILURE = `${NAME}/GENERATE_PROPOSAL_FAILURE`;
export const GENERATE_PROPOSAL_SUCCESS = `${NAME}/GENERATE_PROPOSAL_SUCCESS`;

export const INITIALIZE_VALUES = `${NAME}/INITIALIZE_VALUES`;

export const RESET_FORM = `${NAME}/RESET_FORM`;
export const RESET_VALUES = `${NAME}/RESET_VALUES`;

export const SAVE_SEGMENT = `${NAME}/SAVE_SEGMENT`;
export const SAVE_SEGMENT_FAILURE = `${NAME}/SAVE_SEGMENT_FAILURE`;
export const SAVE_SEGMENT_SUCCESS = `${NAME}/SAVE_SEGMENT_SUCCESS`;

export const SET_CURRENT_VALUES = `${NAME}/SET_CURRENT_VALUES`;
export const SET_GRID_CONFIG = `${NAME}/SET_GRID_CONFIG`;
export const SET_HAS_GROUPS_CONFIG_ERRORS = `${NAME}/SET_HAS_GROUPS_CONFIG_ERRORS`;
export const SELECT_SEGMENT = `${NAME}/SELECT_SEGMENT`;

export const SET_IS_DISABLED_EDITION = `${NAME}/SET_IS_DISABLED_EDITION`;

export const UPDATE_SEGMENTS = `${NAME}/UPDATE_SEGMENTS`;
export const UPDATE_SOLAR_MODULES_DESIGN_NUMBER = `${NAME}/UPDATE_SOLAR_MODULES_DESIGN_NUMBER`;
